import { render, staticRenderFns } from "./CalendarStats.vue?vue&type=template&id=6809318c&scoped=true"
import script from "./CalendarStats.vue?vue&type=script&lang=js"
export * from "./CalendarStats.vue?vue&type=script&lang=js"
import style0 from "./CalendarStats.vue?vue&type=style&index=0&id=6809318c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6809318c",
  null
  
)

export default component.exports